import { defineMessages } from '@atlassian/jira-intl';
import type { FlagConfiguration } from '../../../../services/types.tsx';

const messages = defineMessages({
	title: {
		id: 'platform.ui.flags.flags.errors.generic-error.title',
		defaultMessage: "Something's gone wrong",
		description: '',
	},
	description: {
		id: 'platform.ui.flags.flags.errors.generic-error.description',
		defaultMessage: 'Refresh the page and try again.',
		description: '',
	},
});

const genericError = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
	messageType: 'transactional',
});

export default genericError;
